import { render, staticRenderFns } from "./VolvoDisclosure.vue?vue&type=template&id=3bb7f769&"
import script from "./VolvoDisclosure.vue?vue&type=script&lang=js&"
export * from "./VolvoDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports